export const SOCKET_CONNECTED = 'SOCKET_CONNECTED';
export const SET_CACHE_ID = 'SET_CACHE_ID';
export const SET_FITLERS_URL = 'SET_FITLERS_URL';
export const UPDATE_FILTER_URL = 'UPDATE_FILTER_URL';

export const socketConnected = socket => {
    return {
        type: SOCKET_CONNECTED,
        socket
    }
};

export const setCacheId = (cacheId, code) => {
    return {
        type: SET_CACHE_ID,
        cacheId,
        code
    }
};

export const setFiltersUrl = filters => {
    return {
        type: SET_FITLERS_URL,
        filters
    }
};

export const updateFilterUrl = filter => {
    return {
        type: UPDATE_FILTER_URL,
        filter
    }
};



// WEBPACK FOOTER //
// ./src/actions/SocketActions.js